import {useAppSelector} from '@/shared/hooks/redux';
import {useTestsByName, useSubscription} from '@/modules/patient-dashboard/hooks/useTestsQuery';
import {selectCurrentPatient} from '@/slices/patientSlice';

/**
 * Custom hook for dashboard components to get the patient's lab data.
 * Lab data is never gated by membership — always returns the patient's real data.
 * `isSubscribed` is still returned so the upsell card can hide for members.
 */
export const useDashboardData = () => {
    const currentPatient = useAppSelector(selectCurrentPatient);
    const subscription = useSubscription();
    const realPatientData = useTestsByName(currentPatient?.fullName || '');

    // Lab data is never gated by membership — always the patient's real data.
    // `isSubscribed` is returned only so the upsell card can hide for members.
    return {
        data: realPatientData,
        isSubscribed: subscription,
    };
};

export default useDashboardData;
